import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from '../../assets/styles/globalStyles';
import defaultTheme from '../../assets/styles/themes/default';
import { queryClient } from '../../lib/queryClient';
import Routes from '../../routes';
import Footer from '../Footer';
import Header from '../Header';
import PopUpEntering from '../PopUpEntering';
import ScrollToTop from '../ScrollToTop';
import { AppContainer } from './styles';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={defaultTheme}>
        <GlobalStyles />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: '#333',
              color: '#fff',
            },
          }}
        />

        <BrowserRouter>
          <ScrollToTop />
          <AppContainer>
            <PopUpEntering />
            <Header />
            <Routes />
            <Footer />
          </AppContainer>
        </BrowserRouter>

        <ReactQueryDevtools initialIsOpen />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
